window.TreeHelper = {};

TreeHelper.m = [20, 120, 20, 300];
TreeHelper.w = 5080 - TreeHelper.m[1] - TreeHelper.m[3];
TreeHelper.h = 800 - TreeHelper.m[0] - TreeHelper.m[2];
TreeHelper.i = 0;

if(window.d3) {
  TreeHelper.tree = d3.layout.tree()
      .size([TreeHelper.h, TreeHelper.w]);

  TreeHelper.diagonal = d3.svg.diagonal()
      .projection(function(d) { return [d.y, d.x]; });

  TreeHelper.vis = d3.select("div#tree").append("svg:svg")
      .attr("width", TreeHelper.w + TreeHelper.m[1] + TreeHelper.m[3])
      .attr("height", TreeHelper.h + TreeHelper.m[0] + TreeHelper.m[2])
    .append("svg:g")
      .attr("transform", "translate(" + TreeHelper.m[3] + "," + TreeHelper.m[0] + ")");
}

TreeHelper.root = {};

TreeHelper.getJsonTree = function() {
    var succeed = false;

    $.ajax({
    async: false,
    url: '/get_divisions',
    success: function(data) {
         succeed = data;
         console.log(data);
    }});

    return succeed;
}

TreeHelper.toggleAll = function(d){
    if (d.children) {
      d.children.forEach(TreeHelper.toggleAll);
      TreeHelper.toggle(d);
    }
}

TreeHelper.update = function(source) {
  var duration = d3.event && d3.event.altKey ? 5000 : 500;

  // Compute the new tree layout.
  var nodes = TreeHelper.tree.nodes(TreeHelper.root).reverse();

  // Normalize for fixed-depth.
  nodes.forEach(function(d) { d.y = d.depth * 180; });

  // Update the nodes…
  var node = TreeHelper.vis.selectAll("g.node")
      .data(nodes, function(d) { return d.id || (d.id = ++TreeHelper.i); });

  // Enter any new nodes at the parent's previous position.
  var nodeEnter = node.enter().append("svg:g")
      .attr("class", "node")
      .attr("transform", function(d) { return "translate(" + source.y0 + "," + source.x0 + ")"; });


  nodeEnter.append("svg:circle")
      .attr("r", 1e-6)
      .style("fill", function(d) { return d._children ? "lightsteelblue" : "#fff"; })
      .on("click", function(d) { TreeHelper.toggle(d); TreeHelper.update(d); });

  nodeEnter.append('a')
      .attr('data-iddiv', function(d) {
        return d.id;
      })
      .attr('onclick', function(d) {
        if(d.isContragenty !== true)
  //           Q.fnOpenModal
  // ({

  //   sUrl: sUrl,
  //   oParams: oParams,
  //   bOpenLeft: bOpenLeft
  // });
          return 'Q.fnOpenModal({sUrl:"/q/tree_of_staff", oParams: { externvar:{ staff_id:'+d.id+' }}, bOpenLeft: true })';
        // return 'QForm.fnOpenForm ({sEntity:"list_of_staff",   id: '+d.id+',   oExternVars: { request_id:'+d.id+'}, bOpenLeft: true});';
      })
      .attr('href', 'javascript:void(0);')
      .append("svg:text")
      .attr("x", function(d) { return d.children || d._children ? -12 : 12; })
      .attr("dy", ".35em")
      .attr("text-anchor", function(d) { return d.children || d._children ? "end" : "start"; })
      .text(function(d) { return d.name; })
      .style('fill', function(d) {
        return d.free ? 'black' : '#999';
      })
      .style("fill-opacity", 1e-6)
      .style("font-size", '0.9em');

  nodeEnter.append("svg:title")
    .text(function(d) {
      return d.description;
    });

  // Transition nodes to their new position.
  var nodeUpdate = node.transition()
      .duration(duration)
      .attr("transform", function(d) { return "translate(" + d.y + "," + d.x + ")"; });

  nodeUpdate.select("circle")
      .attr("r", 8)
      .style("fill", function(d) { return d._children ? "lightsteelblue" : "#fff"; });

  nodeUpdate.select("text")
      .style("fill-opacity", 1);

  // Transition exiting nodes to the parent's new position.
  var nodeExit = node.exit().transition()
      .duration(duration)
      .attr("transform", function(d) { return "translate(" + source.y + "," + source.x + ")"; })
      .remove();

  nodeExit.select("circle")
      .attr("r", 1e-6);

  nodeExit.select("text")
      .style("fill-opacity", 1e-6);

  // Update the links…
  var link = TreeHelper.vis.selectAll("path.link")
      .data(TreeHelper.tree.links(nodes), function(d) { return d.target.id; });

  // Enter any new links at the parent's previous position.
  link.enter().insert("svg:path", "g")
      .attr("class", "link")
      .attr("d", function(d) {
        var o = {x: source.x0, y: source.y0};
        return TreeHelper.diagonal({source: o, target: o});
      })
    .transition()
      .duration(duration)
      .attr("d", TreeHelper.diagonal);

  // Transition links to their new position.
  link.transition()
      .duration(duration)
      .attr("d", TreeHelper.diagonal);

  // Transition exiting nodes to the parent's new position.
  link.exit().transition()
      .duration(duration)
      .attr("d", function(d) {
        var o = {x: source.x, y: source.y};
        return TreeHelper.diagonal({source: o, target: o});
      })
      .remove();

  // Stash the old positions for transition.
  nodes.forEach(function(d) {
    d.x0 = d.x;
    d.y0 = d.y;
  });
}

TreeHelper.toggle = function(d){
  if (d.children) {
    d._children = d.children;
    d.children = null;
  } else {
    d.children = d._children;
    d._children = null;
  }
}
